import useFirebase from './useFirebase';

export default function useAuth() {
  const firebase = useFirebase();
  return firebase.auth;
}
